import _classCallCheck from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/jenkins/workspace/jenkins-prod-pipelines-LOS-UI-Login-UI-prod-10/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import PropTypes from "prop-types";
import React from "react";
import { maskMap } from "@defi/core-utils";
import { noop, returnTrue, charIsNumber, escapeRegExp, fixLeadingZero, limitToScale, roundToPrecision, omit, setCaretPosition, splitDecimal, findChangedIndex, clamp, applyThousandSeparator, getCurrentCaretPosition } from "./maskUtilities";
var propTypes = {
  displayType: PropTypes.oneOf(["input", "text"]),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onValueChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  onMouseUp: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  type: PropTypes.oneOf(["text", "tel", "password"]),
  mask: PropTypes.object,
  renderText: PropTypes.func,
  getInputRef: PropTypes.func
};
var defaultProps = {
  displayType: "input",
  type: "text",
  mask: {
    hasMask: false
  },
  onValueChange: noop,
  onChange: noop,
  onKeyDown: noop,
  onMouseUp: noop,
  onFocus: noop,
  onBlur: noop,
  getInputRef: noop
};

var MaskedInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(MaskedInput, _React$Component);

  function MaskedInput(props) {
    var _this;

    _classCallCheck(this, MaskedInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MaskedInput).call(this, props));

    _this.formatValue = function (value) {
      if (_this.props.mask.hasMask) {
        if (_this.props.mask.editMask) {
          return maskMap.getMaskedValue(value, _this.props.mask.editMask, true);
        } else {
          return maskMap.getMaskedValue(value, _this.props.mask.readEditMask, true);
        }
      } else {
        return value;
      }
    };

    var defaultValue = props.defaultValue; // console.log(defaultValue);

    var formattedValue = _this.props.value;
    _this.state = {
      value: formattedValue
    };
    _this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    _this.onMouseUp = _this.onMouseUp.bind(_assertThisInitialized(_this));
    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_this));
    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(MaskedInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.updateValueIfRequired(prevProps);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextState, nextProps) {
      // console.log(nextProps.value);
      // console.log(this.state.value);
      // console.log(nextProps.value != this.state.value);
      return nextProps.value != this.state.value;
    }
  }, {
    key: "updateValueIfRequired",
    value: function updateValueIfRequired(prevProps) {
      var props = this.props,
          state = this.state,
          focusedElm = this.focusedElm;
      var stateValue = state.value;

      if (prevProps !== props) {
        var formattedValue = this.formatValue(props.value); // === undefined ? lastValueWithNewFormat : this.formatValueProp();

        if ( //set state always when not in focus and formatted value is changed
        focusedElm === null && formattedValue !== stateValue) {
          this.updateValue({
            formattedValue: formattedValue,
            input: focusedElm
          });
        }
      }
    }
    /** caret specific methods **/

  }, {
    key: "setPatchedCaretPosition",
    value: function setPatchedCaretPosition(el, caretPos, currentValue) {
      /* setting caret position within timeout of 0ms is required for mobile chrome,
        otherwise browser resets the caret position after we set it
        We are also setting it without timeout so that in normal browser we don't see the flickering */
      setCaretPosition(el, caretPos);
      setTimeout(function () {
        if (el.value === currentValue) setCaretPosition(el, caretPos);
      }, 0);
    }
    /* This keeps the caret within typing area so people can't type in between prefix or suffix */

  }, {
    key: "correctCaretPosition",
    value: function correctCaretPosition(value, caretPos, direction) {
      var format = this.props.format; //if value is empty return 0

      if (value === "") return 0; //caret position should be between 0 and value length

      caretPos = clamp(caretPos, 0, value.length);
      return caretPos;
    }
  }, {
    key: "getCaretPosition",
    value: function getCaretPosition(inputValue, formattedValue, caretPos) {
      caretPos += formattedValue.length - inputValue.length;
      return caretPos;
    }
    /** caret specific methods ends **/

  }, {
    key: "updateValue",

    /** Update value and caret position */
    value: function updateValue(params) {
      var onUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var formattedValue = params.formattedValue,
          input = params.input;
      var caretPos = params.caretPos;
      var lastValue = this.state.value; //set caret position, and value imperatively when element is provided

      if (input) {
        //calculate caret position if not defined
        if (!caretPos) {
          var inputValue = params.inputValue || input.value;
          var currentCaretPosition = getCurrentCaretPosition(input); // console.log(currentCaretPosition)
          // get the caret position

          caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition); // console.log(caretPos)
        } //set the value imperatively, this is required for IE fix


        input.value = formattedValue; //set caret position

        this.setPatchedCaretPosition(input, caretPos, formattedValue);
      } //update state if value is changed


      if (formattedValue !== lastValue) {
        this.setState({
          value: formattedValue
        }, function () {
          onUpdate();
        });
      } else {
        onUpdate();
      }
    }
  }, {
    key: "onChange",
    value: function onChange(e) {
      e.persist();
      var el = e.target;
      var inputValue = el.value;
      var state = this.state,
          props = this.props;
      var currentCaretPosition = getCurrentCaretPosition(el);
      var formattedValue = this.formatValue(inputValue) || ""; // console.log("onChange: " + inputValue + ' - ' + formattedValue)

      this.updateValue({
        formattedValue: formattedValue,
        inputValue: inputValue,
        input: el
      }, function () {// props.onChange(e);
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var props = this.props,
          state = this.state;
      var format = props.format,
          onBlur = props.onBlur; // let {numAsString} = state;

      var lastValue = state.value;
      this.focusedElm = null;

      if (!format) {
        var formattedValue = this.formatValue(lastValue); // console.log("onBlur: " + lastValue + ' - ' + formattedValue)
        //change the state

        if (formattedValue !== lastValue) {
          // the event needs to be persisted because its properties can be accessed in an asynchronous way
          e.persist();
          this.updateValue({
            formattedValue: formattedValue
          }, function () {
            onBlur(e);
          });
          return;
        }
      }

      onBlur(e);
    }
  }, {
    key: "onKeyDown",
    value: function onKeyDown(e) {
      var el = e.target;
      var key = e.key;
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          _el$value = el.value,
          value = _el$value === void 0 ? "" : _el$value;
      var expectedCaretPosition;
      var _this$props = this.props,
          format = _this$props.format,
          onKeyDown = _this$props.onKeyDown;
      this.selectionBeforeInput = {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
      }; //Handle backspace and delete against non numerical/decimal characters or arrow keys

      if (key === "ArrowLeft" || key === "Backspace") {
        expectedCaretPosition = selectionStart - 1;
      } else if (key === "ArrowRight") {
        expectedCaretPosition = selectionStart + 1;
      } else if (key === "Delete") {
        expectedCaretPosition = selectionStart;
      } //if expectedCaretPosition is not set it means we don't want to Handle keyDown
      //also if multiple characters are selected don't handle


      if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
        onKeyDown(e);
        return;
      }

      var newCaretPosition = expectedCaretPosition;
      var leftBound = 0; //isPatternFormat ? format.indexOf('#') : prefix.length;

      var rightBound = value.length; //isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;
      // console.log("onKeyDown: " + value + ' - ' + key)

      if (key === "ArrowLeft" || key === "ArrowRight") {
        var direction = key === "ArrowLeft" ? "left" : "right";
        newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
      } else if (key === "Delete") {
        while (newCaretPosition < rightBound) {
          newCaretPosition++;
        }
      } else if (key === "Backspace") {
        /* NOTE: This is special case when backspace is pressed on a
           negative value while the cursor position is after prefix. We can't handle it on onChange because
           we will not have any information of keyPress
           */
        if (selectionStart <= leftBound + 1 && value[0] === "-" && typeof format === "undefined") {
          var newValue = value.substring(1); //persist event before performing async task

          e.persist();
          this.updateValue({
            formattedValue: newValue,
            caretPos: newCaretPosition,
            input: el
          });
        }
      }

      if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
        e.preventDefault();
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }

      this.props.onKeyDown(e);
    }
    /** required to handle the caret position when click anywhere within the input **/

  }, {
    key: "onMouseUp",
    value: function onMouseUp(e) {
      var el = e.target;
      /**
         * NOTE: we have to give default value for value as in case when custom input is provided
         * value can come as undefined when nothing is provided on value prop.
        */

      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          _el$value2 = el.value,
          value = _el$value2 === void 0 ? "" : _el$value2; // console.log("onMouseUp: " + value)

      if (selectionStart === selectionEnd) {
        var caretPosition = this.correctCaretPosition(value, selectionStart);

        if (caretPosition !== selectionStart) {
          this.setPatchedCaretPosition(el, caretPosition, value);
        }
      }

      this.props.onMouseUp(e);
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      var _this2 = this;

      // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
      // (onFocus event target selectionStart is always 0 before setTimeout)
      e.persist();
      this.focusedElm = e.target;
      setTimeout(function () {
        var el = e.target;
        var selectionStart = el.selectionStart,
            selectionEnd = el.selectionEnd,
            _el$value3 = el.value,
            value = _el$value3 === void 0 ? "" : _el$value3; //console.log("onFocus: " + value)

        var caretPosition = _this2.correctCaretPosition(value, selectionStart); //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)


        if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) {
          _this2.setPatchedCaretPosition(el, caretPosition, value);
        } //this.props.onFocus(e);

      }, 0);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          type = _this$props2.type,
          displayType = _this$props2.displayType,
          customInput = _this$props2.customInput,
          renderText = _this$props2.renderText,
          getInputRef = _this$props2.getInputRef,
          mask = _this$props2.mask;
      var value = this.state.value;
      var otherProps = omit(this.props, propTypes);
      var inputProps = Object.assign({}, otherProps, {
        type: type,
        value: value,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onMouseUp: this.onMouseUp,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      });

      if (displayType === "text") {
        return renderText ? renderText(value) || null : React.createElement("span", Object.assign({}, otherProps, {
          ref: getInputRef
        }), value);
      } else if (customInput) {
        var CustomInput = customInput;
        return React.createElement(CustomInput, Object.assign({}, inputProps, {
          mask: mask,
          ref: getInputRef
        }));
      }

      return React.createElement("input", Object.assign({}, inputProps, {
        ref: getInputRef
      }));
    }
  }]);

  return MaskedInput;
}(React.Component);

MaskedInput.defaultProps = defaultProps;
export default MaskedInput;